import { CommonResponse, FixedComponentsRateChartRequest, OcaenFreightRateRequest, OcaenFreightRateRequestDto, OcaenFreightRateResponseModel, OceanTotalAmountRequest } from "@gtpl/shared-models/masters"
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages"
import { Controller, Post, Body } from "@nestjs/common"
import { ApiTags } from "@nestjs/swagger"
import { OcaenFreightRateService } from "./ocaen-freight-rates-service"

@ApiTags('ocaen-freight-rates')
@Controller('ocaen-freight-rates')
export class OcaenFreightRatesController{
    constructor(
        private service:OcaenFreightRateService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

    ){}
    @Post('/create')
    async create(@Body() req:OcaenFreightRateRequestDto,updated:boolean):Promise<OcaenFreightRateResponseModel>{
        try{
            return await this.service.create(req)
        }catch(err){
            return this.applicationExceptionhandler.returnException(OcaenFreightRateResponseModel,err)
        }
    }
    @Post('/getAllOcaenFreightRates')
    async getAllOcaenFreightRates():Promise<OcaenFreightRateResponseModel>{
        try{
            return await this.service.getAllOcaenFreightRates()
        }catch(err){
            return this.applicationExceptionhandler.returnException(OcaenFreightRateResponseModel,err)
        }
    }

    @Post('/getAllOcaenFreightRatesForInvoice')
    async getAllOcaenFreightRatesForInvoice(@Body() req:OceanTotalAmountRequest):Promise<CommonResponse>{
        console.log(req,'bgh')
        try{
            return await this.service.getAllOcaenFreightRatesForInvoice(req)
        }catch(err){
            return this.applicationExceptionhandler.returnException(OcaenFreightRateResponseModel,err)
        }
    }
    
}